import { Component, inject } from '@angular/core'

import { MessagesService } from '@shared/services'
import { Icon } from '../icon/icon'

@Component({
  selector: 'app-toast-tray',
  imports: [Icon],
  templateUrl: './toast-tray.html',
  host: {
    class: 'pointer-events-none fixed inset-x-4 bottom-4 z-50 flex flex-col items-end gap-2 sm:inset-x-auto sm:right-6 sm:bottom-6'
  }
})
export class ToastTray {
  #messagesService = inject(MessagesService)

  toasts = this.#messagesService.toasts

  dismiss(id: number): void {
    this.#messagesService.dismiss(id)
  }
}
